module.exports = __webpack_public_path__ + "select2x2.49e3f.png";